const menus = [
    { name: "Empresa", path: "/dashboard/empresa", roles: [4] },
    { name: "Clients", path: "/dashboard/clients", roles: [3, 4] },
    { name: "Proveïdors", path: "/dashboard/proveidors", roles: [3, 4] },
    { name: "Empleats", path: "/dashboard/empleats", roles: [3, 4] },
    {
      name: "Pressupostos",
      roles: [3, 4],
      children: [
        {
          name: "Pressupostos",
          path: "/dashboard/pressupostos",
          roles: [3, 4]
        },
        {
          name: "Plantilles",
          path: "/dashboard/plantilles",
          roles: [4]
        }
      ]
    },
    { name: "Treballs", path: "/dashboard/treballs", roles: [3, 4] },
    { name: "Fulls de Treball", path: "/dashboard/fullstreballs", roles: [3, 4] },
    {
      name: "Productes",
      roles: [3, 4],
      children: [
        {
          name: "Productes",
          path: "/dashboard/productes",
          roles: [3, 4]
        },
        {
          name: "Materials",
          path: "/dashboard/materials",
          roles: [3, 4]
        },
        {
          name: "Tipus de Materials",
          path: "/dashboard/tipusdematerials",
          roles: [3, 4]
        },
        {
          name: "Categories",
          path: "/dashboard/categories",
          roles: [3, 4]
        }
      ]
    },
    {
      name: "Recursos",
      roles: [3, 4],
      children: [
        {
          name: "Vehicles",
          path: "/dashboard/vehicles",
          roles: [3, 4]
        },
        {
          name: "Eines",
          path: "/dashboard/eines",
          roles: [3, 4]
        },
        {
          name: "Magatzems",
          path: "/dashboard/magatzems",
          roles: [3, 4]
        }
      ]
    },
    {
      name: "Mà d'Obra",
      roles: [4],
      children: [
        {
          name: "Tipus de Mà d'Obra",
          path: "/dashboard/tipusmaobra",
          roles: [4]
        },
        {
          name: "Grups de Mà d'Obra",
          path: "/dashboard/grupsmaobra",
          roles: [4]
        }
      ]
    },
    { name: "Agenda", path: "/dashboard/agenda", roles: [2, 3, 4] },
    {
      name: "Gestió laboral",
      roles: [3, 4],
      children: [
        {
          name: "Horari d'empresa",
          path: "/dashboard/horariempresa",
          roles: [3, 4]
        },
        {
          name: "Calendari laboral",
          path: "/dashboard/calendarilaboral",
          roles: [3, 4]
        },
        {
          name: "Empleats",
          path: "/dashboard/gestiolaboralempleats",
          roles: [3, 4]
        },
        {
          name: "Control Horari",
          path: "/dashboard/gestiolaboralcontrolhorari",
          roles: [3, 4]
        },
        {
          name: "Tipus d'absència",
          path: "/dashboard/tipusabsencia",
          roles: [3, 4]
        },
        {
          name: "Tipus de pausa",
          path: "/dashboard/tipuspausa",
          roles: [3, 4]
        }
      ]
    },
    { name: "Usuaris", path: "/dashboard/usuaris", roles: [4] },
  ];

  export default menus;
